import { ErrorMessage } from "@hookform/error-message";
import { Button } from "@mui/material";
import React, { useContext} from "react";
import { Form, Col, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import AuthContext from "../../../context/user-auth/AuthProvider";

function Forgetpassword(props) {
  const { emailToResetPassword, isLoading } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const handleSubmitEmail = async (data) => {
    const response = await emailToResetPassword(data);

    if (response.data.success) {
      window.$userEmailReset = data;
      window.$userIdReset = response.data.data.user_id;
      props.shownewpasswordmodal();
    }
  };

  return (
    <Modal {...props} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton body-text-variant="--bs-purple">
        <Modal.Title id="contained-modal-title-vcenter">
          <h6 className="mb-0">Reset Password</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>We will send the OTP to your email.</p>
        <Form onSubmit={handleSubmit(handleSubmitEmail)}>
          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="validationCustom01">
              <Form.Label>Email ID*</Form.Label>
              <Form.Control
                name="forgot_emailId"
                type="email"
                placeholder="name@DCTS.com"
                {...register("email", {
                  required: "Please enter your email address"
                })}
              />
              <ErrorMessage
                errors={errors}
                name="email"
                render={({ message }) => (
                  <Form.Control.Feedback type="invalid" className="d-block">
                    {message}
                  </Form.Control.Feedback>
                )}
              />
            </Form.Group>
          </Row>

          <Button variant="contained" color="error" className={`d-flex m-auto ${isLoading ? "btn-loading" : ""}`} type="submit" disabled={isLoading} >
            Reset My Password
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default Forgetpassword;
